import React from 'react';
import { Quote } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';

const Testimonials = () => {
  // Scroll reveal hooks
  const headerReveal = useScrollReveal({ threshold: 0.2 });
  const cardsReveal = useScrollReveal({ threshold: 0.1 });

  const testimonials = [
    {
      quote: "His excitement at the gate tells me everything.",
      author: "Pet Parent"
    },
    {
      quote: "I stopped feeling guilty about travelling.",
      author: "Frequent Traveller & Dog Parent"
    },
    {
      quote: "They don't just care for dogs. They understand them.",
      author: "Domigo Client"
    }
  ];
  

  return (
    <section className="bg-gradient-purple py-16 lg:py-24 relative overflow-hidden">
      {/* Decorative elements with animation */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-white/10 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-domigo-purple/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header with scroll reveal */}
        <div 
          ref={headerReveal.ref}
          className={`text-center mb-16 transition-all duration-800 ${
            headerReveal.isVisible 
              ? 'opacity-100 translate-y-0' 
              : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
            Don’t trust our marketing. Trust dog behaviour.
          </h2>
          <p className="text-lg lg:text-xl text-white/95 max-w-3xl mx-auto">
            Dogs who visit once… <br/>
           Pull their parents back the second time. 
          </p>
        </div>

        {/* Professional card layout for feedback with stagger animation */}
        <div 
          ref={cardsReveal.ref}
          className="grid grid-cols-1 md:grid-cols-3 gap-8"
        >
          {testimonials.map((t, i) => (
            <div
              key={i}
              className={`bg-white rounded-3xl p-6 depth-xl hover-lift transition-all duration-800 ${
                cardsReveal.isVisible 
                  ? 'opacity-100 translate-y-0' 
                  : 'opacity-0 translate-y-12'
              }`}
              style={{
                transitionDelay: cardsReveal.isVisible ? `${i * 150}ms` : '0ms'
              }}
            >
              <div className="mb-4">
                <Quote className="text-domigo-pink" size={28} />
              </div>
              <p className="text-gray-900 text-lg italic mb-4">{`“${t.quote}”`}</p>
              <div className="text-sm text-gray-600 font-semibold">— {t.author}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
